import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../../types';
import BaseButton from './BaseButton';
import { EditIcon } from '../../icons/EditIcon';
import { setModalToDisplay } from '../../../../core/legacy/actions/modals';

type DispatchButtonProps = {
    title: string;
    modalType: string;
};

const DispatchButton = ({ title, modalType }: DispatchButtonProps) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();

    return (
        <BaseButton onClick={() => dispatch(setModalToDisplay(modalType))} variant="secondary">
            <EditIcon />
            {t(title)}
        </BaseButton>
    );
};

export default DispatchButton;
